module.exports = "/_next/static/images/8a5787e4ee4e5e2edc8975e743b832ad-Protect yourself_lg.png.webp";